import React from "react";
import { useParams } from "react-router-dom";
import { blogs } from "./blogData";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { FaLinkedin, FaInstagram } from "react-icons/fa6";
function BlogDetail() {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);

  if (!blog) return <h2 className="container py-5">Blog not found</h2>;

  // 🔥 Converts /internal-links into clickable SEO links

const linkifyText = (text) => {
  // Match full URLs (http, https) OR internal links starting with /
  const urlRegex = /(https?:\/\/[^\s]+)|(\/[^\s]+)/g;

  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = urlRegex.exec(text)) !== null) {
    const url = match[0];
    const index = match.index;

    // Push text before link
    if (index > lastIndex) {
      parts.push(text.substring(lastIndex, index));
    }

    if (url.startsWith("http")) {
      // External link
      parts.push(
        <a
          key={index}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#0d6efd",
            textDecoration: "underline",
            fontWeight: 500,
          }}
        >
          {url}
        </a>
      );
    } else if (url.startsWith("/")) {
      // Internal link
      parts.push(
        <Link
          key={index}
          to={url}
          style={{
            color: "#0d6efd",
            textDecoration: "underline",
            fontWeight: 500,
          }}
        >
          {url}
        </Link>
      );
    }

    lastIndex = index + url.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts;
};

  return (
    <div className="container py-5 mt-4">
      <Navbar></Navbar>
      {/* ✅ SEO BOOST */}
      <Helmet>
        <title>{blog.title} | AzyByte Technologies</title>
        <meta name="description" content={blog.description} />
          <meta name="author" content="AzyByte Technologies"/>
        <link
          rel="canonical"
          href={`https://www.azybyte.in/blog/${blog.slug}`}
        />

        <meta property="og:title" content={blog.title} />
        <meta property="og:description" content={blog.description} />
        <meta property="og:image" content={blog.image} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://www.azybyte.in/blog/${blog.slug}`} />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            headline: blog.title,
            description: blog.description,
            image: blog.image,
            datePublished: blog.date,
            author: {
              "@type": "Organization",
              name: "AzyByte Technologies"
            },
            publisher: {
              "@type": "Organization",
              name: "AzyByte Technologies",
              logo: {
                "@type": "ImageObject",
                url: "https://www.azybyte.in/azybytelogo.png"
              }
            }
          })}
        </script>
      </Helmet>

      {/* Header */}
      <div className="mb-4">
        <h1 className="fw-bold">{blog.title}</h1>
        <p className="text-muted">{blog.date}</p>
      </div>

      {/* Image */}
      {blog.image && (
        <img
          src={blog.image}
          alt={blog.title}
          className="img-fluid rounded mb-4"
          style={{
            maxHeight: "400px",
            objectFit: "cover",
            width: "100%"
          }}
        />
      )}

      {/* Content */}
      <div className="blog-content">

        {Array.isArray(blog.content) ? (
          blog.content.map((block, index) => {
            switch (block.type) {

              case "heading":
                return (
                  <h3 key={index} className="mt-4 fw-bold">
                    {block.text}
                  </h3>
                );

              case "paragraph":
                return (
                  <p key={index} className="text-muted fs-5 mt-3">
                    {linkifyText(block.text)}
                  </p>
                );

              case "list":
                return (
                  <ul key={index} className="mt-3">
                    {block.items.map((item, i) => (
                      <li key={i} className="mb-2 text-muted">
                        {linkifyText(item)}
                      </li>
                    ))}
                  </ul>
                );

              case "image":
                return (
                  <div key={index} className="my-4">
                    <img
                      src={block.url}
                      alt={block.alt}
                      className="img-fluid rounded shadow-sm"
                      style={{
                        width: "100%",
                        maxHeight: "400px",
                        objectFit: "cover"
                      }}
                    />
                  </div>
                );

              default:
                return null;
            }
          })
        ) : (
          <p className="text-muted fs-5">{blog.content}</p>
        )}
      </div>

      <div className="mt-5">
  <h4 className="fw-bold">
    Related Articles
  </h4>

  <ul>
    {blogs
      .filter((b) => b.slug !== blog.slug)
      .slice(0, 3)
      .map((related) => (
        <li key={related.slug}>
          <Link to={`/blog/${related.slug}`}>
            {related.title}
          </Link>
        </li>
      ))}
  </ul>
</div>

<div className="alert alert-light border mt-5">
  <h5>About AzyByte Technologies</h5>

  <p>
    AzyByte Technologies is an India-based software development
    IT Agency/company specializing in web development, mobile applications, Whatsapp and AI automations,
    enterprise software, cloud solutions, SEO, and digital marketing.
    We help businesses build scalable and innovative digital products.
  </p>
</div>
      {/* Social Links */}
<div className="mt-5 pt-4 border-top">
  <h4 className="fw-bold mb-3">
    Connect with AzyByte Technologies
  </h4>

  <p className="text-muted">
    Follow AzyByte Technologies for web development,
    software solutions, digital marketing, and technology updates.
  </p>

  <div className="d-flex gap-3">
    <a
      href="https://linkedin.com/company/azybytetechnologies"
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-primary"
    >
      <FaLinkedin className="me-2" />
      LinkedIn
    </a>

    <a
      href="https://instagram.com/azybytetech"
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-danger"
    >
      <FaInstagram className="me-2" />
      Instagram
    </a>
  </div>
</div>

    </div>
  );
}

export default BlogDetail;